import React from 'react';
import { genericMemo } from '@direct-frontend/stdlib';

import { cn } from '../../lib/css/className/className';
import { Cell } from '../Cell';
import { TestProps } from '../../internal/types/testTypes';
import { CellProps } from '../Cell';
import { CellSizeContext } from '../Table/context';

import './EmptyCell.css';

const elementSize = '20';

const cls = cn('EmptyCell');

export type EmptyCellProps = TestProps &
    Pick<CellProps, 'topPadding' | 'bottomPadding' | 'rightPadding' | 'leftPadding' | 'size'>;

export const EmptyCell = genericMemo(function EmptyCell(props: EmptyCellProps) {
    const {
        'data-testid': dataTestId = 'EmptyCell',
        size: cellSize = 'm',
        topPadding = true,
        bottomPadding = true,
        leftPadding = true,
        rightPadding = true,
        ...cellProps
    } = props;

    const tableSize = React.useContext(CellSizeContext);

    const size = tableSize ?? cellSize;

    return (
        <Cell
            {...cellProps}
            className={cls('', {
                size,
                topPadding,
                bottomPadding,
                leftPadding,
                rightPadding,
            })}
            data-testid={dataTestId}
            isGrowable={false}
        >
            <div
                style={{
                    width: `${elementSize}px`,
                    height: `${elementSize}px`,
                }}
            />
        </Cell>
    );
});
